import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import TableHeaderCellElement from "./TableHeaderCell";
var propTypes = {
  theme: PropTypes.shape({
    tableHeaderCell: PropTypes.oneOf(['dark'])
  }),
  active: PropTypes.bool,
  align: PropTypes.oneOf(['left', 'right', 'center']),
  selectable: PropTypes.bool
};
var defaultProps = {
  align: 'left',
  theme: {}
};
export default function TableHeaderCell(_ref) {
  var theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["theme"]);

  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(TableHeaderCellElement, props));
}
TableHeaderCell.darkTheme = {
  tableHeaderCell: 'dark'
};
TableHeaderCell.propTypes = propTypes;
TableHeaderCell.defaultProps = defaultProps;